import { useFlags } from "flagsmith/react";

import { GLOBAL_FLAGS_ENUM as FLAGS } from "@utils/featureFlags";
import { cnpjConfig } from "@utils/fiscal/cnpj/config";

/**
 * Sincroniza a feature flag de CNPJ alfanumérico com o config global.
 *
 * Deve ser chamado em um componente que monta cedo na árvore (ex: Header).
 * Após a sincronização, todas as funções utilitárias (maskCNPJ, unmaskCNPJ,
 * formatCNPJOrCPF, isValidCNPJ, validateDocument) respeitam a flag automaticamente.
 *
 * Não é necessário usar as funções retornadas — elas existem apenas para
 * conveniência em componentes que já importam o hook.
 */
export const useCnpjRules = () => {
  const flags = useFlags([FLAGS.ENABLE_ALPHANUMERIC_CNPJ]);
  const enableAlphanumeric = !!flags[FLAGS.ENABLE_ALPHANUMERIC_CNPJ]?.enabled;

  cnpjConfig.allowAlphanumeric = enableAlphanumeric;
  console.info("alphanumeric_cnpj isEnable?: ", enableAlphanumeric);

  return { enableAlphanumeric };
};
